module.exports = __webpack_public_path__ + "static/media/revolver2.01cbc006.png";